<template>
    <input ref="input"
        v-model="localValue"
        type="search"
        autocomplete="disable-autocomplete"
        :placeholder="localPlaceholder"
        :class="['form-control', inputClass]"
        onfocus="this.setAttribute('autocomplete', 'disable-autocomplete');"
        />
</template>
<script>
export default {
    data() {
        return {
            localValue: null,
            selected: {},
        }
    },

    props: ['value', 'config', 'placeholder'],

    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localValue = newVal;
                }
            },
            immediate: true,
        },
    },

    created() {

    },

    mounted() {
        this.init();
    },

    computed: {
        fulladdress() {
            return _.get(this.config, 'fulladdress', false);
        },

        inputClass() {
            return _.get(this.config, 'inputClass', 'form-control-md');
        },

        listContainer() {
            return _.get(this.config, 'container', false);
        },

        localPlaceholder() {
            return _.get(this, 'placeholder', 'Search address here...');
        },
    },

    methods: {
        init() {
            window.VueGoogleMaps.loaded.then(() => {
                const autocompleter = new google.maps.places.Autocomplete(
                    (this.$refs.input),
                    {
                        types: ['address'],
                        componentRestrictions: { country: 'nz' }
                    }
                );

                autocompleter.addListener('place_changed', () => {
                    let address = this.fillInAddress(autocompleter);
                    const fullAddress = address.formatted_address;

                    this.selected.address_line_1 = address.street_number + ' ' + address.street_address
                    this.selected.suburb = address.suburb,
                    this.selected.city = address.city,
                    this.selected.postcode = address.postal_code,
                    this.selected.country = 'New Zealand';

                    this.$emit('input', fullAddress);
                    this.$emit('change', this.selected);

                    this.localValue = this.fulladdress ? fullAddress : this.selected.address_line_1;
                });

                $(this.$refs.input).on('input', (e) => {
                    this.$emit('input', e.target.value);
                    this.$emit('change', _.assign({}, this.selected, {
                        address_line_1: e.target.value,
                    }));
                });
            })
        },

        fillInAddress(autocompleter) {

            const componentForm = {
                street_number: 'short_name',
                route: 'long_name', // street
                sublocality_level_1: 'long_name', // suburb if exists
                locality: 'long_name', // city
                administrative_area_level_1: 'short_name', // city
                postal_code: 'short_name'
            };

            // Get the place details from the autocomplete object.
            var place = autocompleter.getPlace();
            var street_number = '';
            var street_address, suburb, locality, city, postal_code;

            // Get each component of the address from the place details
            // and fill the corresponding field on the form.
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                var val = place.address_components[i][componentForm[addressType]];

                if (addressType === "street_number") {
                    street_number = val;
                } else if (addressType === "route") {
                    street_address = val;
                } else if (addressType === "sublocality_level_1") {
                    suburb = val;
                } else if (addressType === "locality") {
                    locality = val;
                } else if (addressType === "administrative_area_level_1") {
                    city = val;
                } else if (addressType === "postal_code") {
                    postal_code = val;
                }
            }

            if (typeof suburb === "undefined"){
                suburb = locality;
            }

            return {
                formatted_address: place.formatted_address,
                street_number,
                street_address,
                suburb,
                locality,
                city,
                postal_code,
            }
        },
    }
};
</script>
